import React from "react";
import ReactDOM from "react-dom/client";
import { Snackbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";

let snackbarRoot;
let snackbarTimeout;

function ShowToast(message, severity = "success") {
  const lang = getFromStorage(STORAGE_KEYS.language);

  // Check if the snackbar root already exists; if not, create one
  if (!snackbarRoot) {
    // Create a div container for the snackbar and append it to the body
    const snackbarDiv = document.createElement("div");
    document.body.appendChild(snackbarDiv);

    // Create a React root for rendering the snackbar
    snackbarRoot = ReactDOM.createRoot(snackbarDiv);

    // Render the snackbar component
    snackbarRoot.render(
      <Snackbar
        open={true}
        autoHideDuration={3000}
        onClose={() => {
          closeSnackbar();
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: lang === "ar" ? "left" : "right",
        }}
      >
        <Alert severity={severity} variant="standard" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    );

    // Set up a timeout to auto-close the snackbar after 3 seconds
    snackbarTimeout = setTimeout(() => {
      closeSnackbar();
    }, 3000);
  }
}

function closeSnackbar() {
  if (snackbarRoot) {
    // Unmount the snackbar and clean up the DOM
    snackbarRoot.unmount();
    snackbarRoot = null;
    clearTimeout(snackbarTimeout);
  }
}

export default ShowToast;
